import { useState } from "react"
import { XIcon } from "lucide-react"
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"

interface Props {
  what: string
  name: string
  empty: boolean
  onRemove: () => void
}

export function RemoveButton({ what, name, empty, onRemove }: Props) {
  const [confirmOpen, setConfirmOpen] = useState(false)

  return <>
    <Button variant="ghost" size="icon-xs" aria-label={`Remove ${what}`} onClick={() => empty ? onRemove() : setConfirmOpen(true)}><XIcon /></Button>
    <AlertDialog open={confirmOpen} onOpenChange={setConfirmOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove this {what}?</AlertDialogTitle>
          <AlertDialogDescription>"{name || `Untitled ${what}`}" will be removed from the item.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onRemove}>Remove</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </>
}
